module.exports = __webpack_public_path__ + "img/talents1_uploadbtn.c6f79bcf.png";